import { Component } from '@angular/core';
import { PROMOTIONAL_FORM } from 'src/app/modules/master/helper/masterForm';
import { MasterApiService } from 'src/app/modules/master/service/master-api.service';

@Component({
  selector: 'app-promotional-info',
  templateUrl: './promotional-info.component.html',
  styleUrls: ['./promotional-info.component.scss']
})
export class PromotionalInfoComponent {
  constructor(private masterApi: MasterApiService) { }
  formData = PROMOTIONAL_FORM
  id: any
  data: any = {};
  setInput(d: any) {
    console.log(d,'promo')
    if (d.id) {
      this.id = d.id;
      this.getData()
    }
  }
  getData() {
    if (this.id) {
      this.masterApi.getById('promotional_office', this.id).then(res => {
        this.data = res.result
      })
    }
  }
}
